import * as types from "./actionTypes";
import { showModalSuccess, hideModalSuccess } from "./modalActions";
import { showAlertSuccess } from "./alertActions";
import contractTierService from "../services/contractTierService";

export function loadContractTierSuccess(contractTiers) {
  return {
    type: types.LOAD_CONTRACT_TIER_SUCCESS,
    contractTiers,
    meta: {
      throttle: true
    }
  };
}

export function getContractTierSuccess(contractTier) {
  return {
    type: types.GET_CONTRACT_TIER_SUCCESS,
    contractTier
  };
}

export function savingContractTier(status = true) {
  return {
    type: types.SAVING_CONTRACT_TIER,
    savingContractTier: status
  };
}

export function createContractTierSuccess(contractTier) {
  return {
    type: types.CREATE_CONTRACT_TIER_SUCCESS,
    contractTier
  };
}

export function updateContractTierSuccess(contractTier) {
  return {
    type: types.UPDATE_CONTRACT_TIER_SUCCESS,
    contractTier
  };
}

export function requestContractTierId(contractTierId) {
  return (dispatch) => {
    dispatch({
      type: types.REQUEST_CONTRACT_TIER_ID,
      contractTierToDelete: contractTierId
    });
  };
}

export function loadContractTiers() {
  return (dispatch) =>
    contractTierService
      .loadContractTiers()
      .then((data) => dispatch(loadContractTierSuccess(data)))
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function getContractTier(id, showDetails = false) {
  return (dispatch) =>
    contractTierService
      .getContractTier(id)
      .then((contractTier) => {
        dispatch(getContractTierSuccess(contractTier));
        if (showDetails) {
          dispatch(showModalSuccess("contractTierModal"));
        }
      })
      .catch((error) => dispatch(showAlertSuccess(error.description, "error")));
}

export function createContractTier(contractTier) {
  return (dispatch) => {
    dispatch(savingContractTier());
    return contractTierService
      .createContractTier(contractTier)
      .then((createdContractTier) => {
        dispatch(createContractTierSuccess(createdContractTier));
        dispatch(savingContractTier(false));
        dispatch(
          showAlertSuccess("Contract Tier created successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingContractTier(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}

export function updateContractTier(contractTier) {
  return (dispatch) => {
    dispatch(savingContractTier());
    return contractTierService
      .updateContractTier(contractTier)
      .then((updatedContractTier) => {
        dispatch(updateContractTierSuccess(updatedContractTier));
        dispatch(savingContractTier(false));
        dispatch(hideModalSuccess("contractTierModal"));
        dispatch(
          showAlertSuccess("Contract Tier updated successfully", "success")
        );
      })
      .catch((error) => {
        dispatch(savingContractTier(false));
        dispatch(showAlertSuccess(error.description, "error"));
      });
  };
}
